import React, {useMemo, useState, useEffect} from "react";
import "./../../utils/Style/pages/Employees.scss";
import {useTable} from "react-table";
import {faArrowDown, faUser} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Table from "../../components/Table";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {
    fetchLegalEmployees,
    setLegalEmployeesError
} from "../../features/legalEmployeesSlice";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "lodash";
import {format} from "date-fns";
import {useOutletContext} from "react-router-dom";
import {Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay} from "@chakra-ui/react";
import TableSkeleton from "../../components/skeletons/TableSkeleton";
import {capitalizeFirstLetters} from "../../features/ValueFormater";
import {handleImageError} from "../../utils/functions";

function EmployeeTemplate() {
    const {status} = useSelector((state) => state.authorization);
    const {loading} = useSelector((state) => state.legalEmployees);

    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [employeesList, setEmployeesList] = useState([]);
    const [disabledEdit, setDisabledEdit] = useState(false);

    const [roles, setRoles] = useState([]);
    const [brancheslist, setBrancheslist] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [editId, setEditId] = useState(-1);
    const [error, setError] = useState(null);

    const entityRole = sessionStorage.getItem("EntityRole");

    const [employeeDetails, setEmployeeDetails] = useState({
        EmployeeID: "",
        FullName: "",
        Position: "",
        RoleID: "",
        ShowBlockButton: true,
        isBlocked: false
    });

    const [editEmployeeDetails, setEditEmployeeDetails] = useState({
        EmployeeID: "",
        RoleID: "",
        newBranchID: "",
        oldBranchID: "",
        Email: "",
    });
    const [modalOpen, setModalOpen] = useState(false);

    const [onOpenQrAfterGenerate] = useOutletContext();

    const dispatch = useDispatch();
    let {employees, positions, branches} = useSelector(state => state.legalEmployees);

    useEffect(() => {
        dispatch(fetchLegalEmployees());
        return () => {
            dispatch(setLegalEmployeesError(null));
        };
    }, []);

    useEffect(() => {
        setEmployeesList(employees);
        setRoles(positions);
        setBrancheslist(branches);
        if (!isEmpty(employees)) setIsDataLoaded(true);
    }, [employees]);

    const resetEdit = ()=>{
        setModalOpen(false);
        setDisabledEdit(false);
        setEditId(-1);
        setError(null);
    }

    useEffect(() => {
        if (status === "COMPLETE") {
            resetEdit()
        }
    }, [status])

    const handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        if(value==="-1"){
            setEditEmployeeDetails((prevFormData) => ({
                ...prevFormData,
                [name]: null,
            }));
        }else{
            setEditEmployeeDetails((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }

    };
    const onCloseQrWhilePending = () => {
        // setStatus("CLOSED");
        // const authCode = authorizationCode;
        // dispatch(getExpAuthCodeOnClose({authCode}));
        // onCloseQrReset();
    }


    const handleBlock = (id, isLegal) => {
        const payload = {
            EmployeeId: id,
        }
        if(isLegal){
            dispatch(setActionType(ACTION_TYPES.BLOCK_LEGAL_EMPLOYEE));
        }else {
            dispatch(setActionType(ACTION_TYPES.BLOCK_EMPLOYEE));
        }
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate();
    }
    const handleDelete = (id, isLegal) => {
        const payload = {
            EmployeeId: id,
        }
        setModalOpen(false);
        if(isLegal){
            dispatch(setActionType(ACTION_TYPES.DELETE_LEGAL_EMPLOYEE));
        }else {
            dispatch(setActionType(ACTION_TYPES.DELETE_EMPLOYEE));
        }
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate();
    }
    const handleEdit = (id) => {
        editId === -1 ? setEditId(id) : setEditId(-1);
        setDisabledEdit(true);
        setError(null);
        setEditEmployeeDetails({
            EmployeeID: employeeDetails.EmployeeID,
            RoleID: employeeDetails.RoleID
        })
    }
    const confirmEdit = (id) => {
        setDisabledEdit(false);
        if(editEmployeeDetails.RoleID){
            const payload = {
                EmployeeID: editEmployeeDetails.EmployeeID,
                RoleID: parseInt(editEmployeeDetails.RoleID)
            }
            resetEdit();

            dispatch(setActionType(ACTION_TYPES.EDIT_LEGAL_EMPLOYEE));
            dispatch(setActionPayload(payload));
            onOpenQrAfterGenerate();
            setEditId(-1);
        } else{
            setError("Position cannot be empty");
        }

    }

    const handleClick = (row) => {
        setEmployeeDetails({
            EmployeeID: row.original.EmployeeID,
            FullName: row.original.FullName,
            Position: row.original.Position,
            Merchant: row.original.Entity,
            BranchID: row.original.BranchID,
            MobileNo: row.original.MobileNo,
            Email: row.original.Email,
            IsLegalEmployee: row.original.IsLegalEmployee,
            ShowBlockButton: row.original.ShowBlockButton,
            isBlocked: row.original.isBlocked
        });
        setModalOpen(true)
    }

    const columns = useMemo(
        () => [
            {
                Header: "Employee Name",
                accessor: "FullName",
                Cell: ({row, cell: {value}}) => {
                    return <div className="showmore">
                        {
                            row.original.ImageUrl ? (
                                <div className="row">
                                    <div className="col-1 avatar-employee p-0"><img id="employeesListAvatar" src={row.original.ImageUrl} alt="avatar" onError={handleImageError}/></div>
                                    <div className="col-9 pt-2">{capitalizeFirstLetters(value)}</div>
                                </div>
                            ) : (
                                <div className="row-8">
                                    <span className="me-2"><FontAwesomeIcon icon={faUser}/></span> {value}
                                </div>
                            )

                        }
                    </div>
                },
            },
            {
                Header: "Position",
                accessor: "Position",
                Cell: ({cell: {value}}) => {
                    return capitalizeFirstLetters(value);
                },
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Merchant",
                accessor: "Entity",
            },
            {
                Header: "Last Access Date",
                accessor: "DateLastAccess",
                Cell: ({value}) =>
                    value ? format(new Date(value), "dd/MM/yyyy") : value,
            },
            {
                Header: "Phone Number",
                accessor: "MobileNo",
            },
            {
                Header: "Email",
                accessor: "Email",
            },
            {
                Header: entityRole!== "ADMIN"? "Action": "",
                accessor: "Action",
                key: "Action",
                Cell: ({row}) => {
                    if(!row.original.ShowBlockButton) return <></>
                    if (row.original.isBlocked) {
                        return <button
                            className="details Unblock"
                            onClick={() => {
                                handleBlock(row.original.EmployeeID, row.original.IsLegalEmployee);
                            }}
                            disabled={entityRole !== "SUPERADMIN"}
                        >Unblock</button>;
                    } else {
                        return <button
                            className="details"
                            onClick={() => {
                                handleBlock(row.original.EmployeeID, row.original.IsLegalEmployee);
                            }}
                            disabled={entityRole !== "SUPERADMIN"}
                        >Block</button>;
                    }
                },
            }
        ],
        [employees]
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({columns, data: employeesList || []});

    return (
        <>
            <div className="employeesTable">
                {loading === "pending" ? (
                    <TableSkeleton/>
                ) : (
                    <Table
                        headerGroups={headerGroups}
                        page={rows}
                        prepareRow={prepareRow}
                        getTableProps={getTableProps}
                        getTableBodyProps={getTableBodyProps}
                        activeRowIndex={activeRowIndex}
                        setActiveRowIndex={setActiveRowIndex}
                        employee={true}
                        handleClick={handleClick}
                    />
                )}

            </div>

            {/* Modal */}
            <div id="modal-part">
                <Modal isOpen={modalOpen && entityRole === "SUPERADMIN"} isCentered onClose={()=>{
                    setDisabledEdit(false);
                }}>
                    <ModalOverlay/>

                    <ModalContent maxW={'40%'}>
                        <ModalHeader>
                            <div id="modalHeader">
                                <div></div>
                                <h2>Employee Details</h2>
                                <button type="button" className="btn-close" onClick={() => {
                                    resetEdit();
                                }}></button>
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <div id="employee-modal">
                                <div className="chak-modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body EditEmployee">
                                            <div className="modalBody">
                                                <div className="row modalRow">
                                                    <div className="col-4 subTitle">Name</div>
                                                    <div className="col-8 subDesc">{capitalizeFirstLetters(employeeDetails.FullName)}</div>
                                                </div>
                                                <div className="row modalRow">
                                                    <div className="col-4 subTitle">Position</div>
                                                    {(disabledEdit && employeeDetails?.IsLegalEmployee) ?
                                                        <select className="col-8 subDesc" name="RoleID" id="account"
                                                                defaultValue={employeeDetails.Position}
                                                                onChange={handleInputChange}>
                                                                <option value={-1}>Select a Role</option>
                                                            {roles.map((role) => <option key={role.value}
                                                                                         value={role.value}>{capitalizeFirstLetters(role.label)}</option>)}
                                                        </select>
                                                        :
                                                        <div className="col-8 subDesc">{capitalizeFirstLetters(employeeDetails.Position)}</div>
                                                    }
                                                    {error && <span className="error">{error}</span>}
                                                </div>
                                                {
                                                    employeeDetails.Merchant &&
                                                    <div className="row modalRow">
                                                        <div className="col-4 subTitle">Merchant</div>
                                                        <div className="col-8 subDesc">{employeeDetails.Merchant}</div>
                                                    </div>
                                                }
                                                {
                                                    employeeDetails.MobileNo &&
                                                    <div className="row modalRow">
                                                        <div className="col-4 subTitle">Phone Number</div>
                                                        <div className="col-8 subDesc">{employeeDetails.MobileNo}</div>
                                                    </div>
                                                }
                                                {
                                                    employeeDetails.Email &&
                                                    <div className="row modalRow">
                                                        <div className="col-4 subTitle">Email</div>
                                                        <div className="col-8 subDesc">{employeeDetails.Email}</div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="modalFooter">
                                                {
                                                    (employeeDetails?.IsLegalEmployee && employeeDetails.ShowBlockButton && !employeeDetails.isBlocked) && (
                                                        <>
                                                            {disabledEdit ?
                                                                <button className="EditEmployee" onClick={() => {
                                                                    confirmEdit(employeeDetails.EmployeeID)
                                                                }}>Confirm Edit</button>
                                                                :
                                                                <button className="EditEmployee" onClick={() => {
                                                                    const selectedRole = roles.find(role => role.label === employeeDetails.Position)?.value;
                                                                    handleEdit(employeeDetails.EmployeeID, selectedRole);
                                                                }}>
                                                                    Edit Details
                                                                </button>
                                                            }
                                                        </>
                                                    )
                                                }

                                                <button className="DeletEmployee" onClick={() => {
                                                    handleDelete(employeeDetails.EmployeeID, employeeDetails.IsLegalEmployee)
                                                }}>Delete Employee
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        </>
    );
}

export default EmployeeTemplate;